import { store } from '@redux/store';
import { fromEvent } from 'rxjs';
import { setModalStep, setSpecId } from '../redux/slices';
import { selectTourableSpecs } from '../redux/selectors';
import cardSpecHome from './cardSpecHome';
import ModalStep from '../enums/modalStep';

export default class SpecSelection {
  constructor(rootComponent) {
    this.rootComponent = rootComponent;
    this.rootComponent.subscribe('domUpdate', this.onDomUpdate);
  }

  static getAvailableSpecsContainer() {
    return document.querySelector(
      '[data-self-guided-available-specs-container]'
    );
  }

  onDomUpdate = event => {
    if (event.detail?.step === ModalStep.SpecSelection) {
      this.rootComponent.setPrimaryButtonDisabled(true);
      this.rootComponent.setSecondaryButtonDisabled(false);
      this.setupEventHandlers();
    } else {
      this.forCardGrid$?.unsubscribe();
    }
  };

  handlePrimaryAction() {
    this.rootComponent.getInitialData();
    store.dispatch(setModalStep({ modalStep: ModalStep.DateTimeSelection }));
  }

  setupEventHandlers() {
    const cardGrid = SpecSelection.getAvailableSpecsContainer();
    if (!cardGrid) {
      return;
    }
    this.forCardGrid$ = fromEvent(cardGrid, 'change').subscribe(event => {
      const cards = cardGrid.querySelectorAll('[data-self-guided-tour-card]');
      const target = event.target;
      // find current card clicked
      const currentCard = Array.from(cards).find(card => card.contains(target));

      // uncheck all the inputs minus currentCard
      cards.forEach(card => {
        if (card !== currentCard) {
          card.querySelector('input[type="checkbox"]').checked = false;
        }
      });

      const isAnyChecked = Array.from(cards).some(
        card => card.querySelector('input[type="checkbox"]').checked
      );

      // set specId
      if (currentCard) {
        const specId = currentCard.getAttribute('data-spec-id');
        this.setSpecData(specId);
      }

      this.rootComponent.setPrimaryButtonDisabled(!isAnyChecked);
    });
  }

  setSpecData(id) {
    const specs = selectTourableSpecs(store.getState());
    const selectedSpec = specs.find(spec => spec.Id === Number(id));
    if (selectedSpec) {
      this.rootComponent.specData = {
        ...this.rootComponent.specData,
        brandName: selectedSpec.BrandName,
        communityId: selectedSpec.CommunityId,
        specId: selectedSpec.Id,
        planName: selectedSpec.PlanName,
        planId: selectedSpec.PlanId,
        price: selectedSpec.Price,
        bedrooms: selectedSpec.Bedrooms,
        bathrooms: selectedSpec.Bathrooms,
        garages: selectedSpec.Garages,
        squareFeet: selectedSpec.SquareFeet,
        address: selectedSpec.Address,
        zip: selectedSpec.Zip,
        city: selectedSpec.City,
        state: selectedSpec.StateAbbreviation,
        Thumbnail: selectedSpec.Thumbnail
      };
      store.dispatch(setSpecId({ specId: Number(id) }));
    }
  }

  renderCardList() {
    const items = selectTourableSpecs(store.getState());
    const specDetails = this.rootComponent.getSpecDetails();
    const { noPhotoUrl } = specDetails;
    const cards = items
      .map(item =>
        cardSpecHome({
          id: item.Id,
          address: item.Address,
          planName: item.PlanName,
          squareFeet: item.SquareFeet,
          bathrooms: item.Bathrooms,
          bedrooms: item.Bedrooms,
          garages: item.Garages,
          price: item.Price,
          imageUrl: !item.Thumbnail ? noPhotoUrl : item.Thumbnail
        })
      )
      .join('');

    return cards;
  }

  render() {
    const { communityName, brandName } = this.rootComponent.getSpecDetails();

    return `
      <div class="nhs-c-self-guided-left-panel">
        <div>   
          <h1 class="nhs-c-heading--self-guided-tour nhs-mq-heading--self-guided-tour-large nhs-u-hide-mobile">
            Available homes to self-tour in ${communityName} by ${brandName}
          </h1>

          <h1 class="nhs-c-heading--self-guided-tour nhs-mq-heading--self-guided-tour-large nhs-u-hide-desktop">
            Available homes to self-tour 
            <small>
              View all homes to self-tour in ${communityName} by ${brandName}.
            </small>
          </h1>

          <div class="nhs-c-notification__placeholder" data-self-guided-tour-notifications></div>          
        </div>
        <div class="nhs-c-self-guided-grid" data-self-guided-available-specs-container>
          ${this.renderCardList()}
        </div>
      </div>
    `;
  }
}
